/**
 * Created by andreaskarantzas on 09.04.2021.
 */
import { makeAutoObservable } from 'mobx';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { v1ParamsToV3Params } from './exploreV3Params';
import { ExploreEntryQueryRequest } from './ExploreEntryQueryRequest';
import { BreathingTechniqueStep, createBreathingTechniqueStep } from './BreathingTechniqueStep';
import { ExploreEntry, createExploreEntry } from './ExploreEntry';
import { ActivityLog, newActivityLog } from '../Activity/ActivityLog';

export type BreathingEntry = ExploreEntry & {
  type: 'breathing';
  activityIdentifier: string;
  data: Record<string, any>;
  technique: BreathingTechniqueStep[];
  createActivityLog(startDate: Date, endDate: Date, data?: Record<string, number>): ActivityLog;
};

export function createBreathingEntry(json?: Partial<BreathingEntry>): BreathingEntry {
  const base = createExploreEntry({ ...json, type: 'breathing' });
  return makeAutoObservable({
    ...base,
    type: 'breathing' as const,
    activityIdentifier: 'breathing',
    data: json?.data ?? {},
    technique: (json?.technique ?? []).map((s: any) => createBreathingTechniqueStep(s)),

    createActivityLog(startDate: Date, endDate: Date, data: Record<string, number> = {}): ActivityLog {
      if (!data.DURATION) {
        data.DURATION = Math.round((endDate.valueOf() - startDate.valueOf()) / 1000);
      }
      return newActivityLog({
        type: 'breathing',
        source: {
          source: 'kinastic',
          sourceId: this.id,
          sourceType: 'explore-entry',
        },
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        data,
      });
    },
  });
}

export const BreathingEntryApi = {
  find(request?: Omit<ExploreEntryQueryRequest, 'type'>): Promise<BreathingEntry[]> {
    return HttpBackend.get(`/coach/explore/v3/entries`, v1ParamsToV3Params({ ...request, type: 'breathing' })).then((res) =>
      (res ?? []).map((r: any) => createBreathingEntry(r)),
    );
  },

  findOne(id: string): Promise<BreathingEntry> {
    return HttpBackend.get(`/coach/explore/v3/entries/${id}`).then((res) => createBreathingEntry(res));
  },
};
